import { useQuery } from "@tanstack/react-query";
import { get, SITE_NAME } from "@/lib/api";

export const useLayout = () => useQuery({ queryKey: ["layout"], queryFn: () => get("/public/layout") });

export const useSeo = () => {
  const { data } = useLayout();
  return { seo: data?.seo || {}, site: data?.settings?.site_name || SITE_NAME };
};

export const fill = (text, vars = {}) => String(text ?? "").replace(/\{(\w+)\}/g, (m, k) => (vars[k] !== undefined ? vars[k] : m));

export const useTexts = (key) => {
  const { data } = useLayout();
  const site = data?.settings?.site_name || SITE_NAME;
  return Object.fromEntries(Object.entries(data?.texts?.[key] || {}).map(([k, v]) => [k, fill(v, { sitio: site })]));
};

export const useEnabled = (key) => !(useLayout().data?.disabled || []).includes(key);

export const usePages = () => useLayout().data?.pages || [];
